import styled from 'styled-components';

export const Container = styled.div`
    padding: 0 0 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const TitleRow = styled.div`
    width: 100%;
    height: 40px;
    min-height: 40px;
    padding: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    cursor: pointer;
    background-color: #222;

    &.expanded {
        margin-bottom: 10px;
    }

    &:hover {
        background-color: #000;
    }
`;

export const Title = styled.div`
    color: #999;
    font-size: 14px;
    text-transform: uppercase;
    flex: 1;
    margin-left: 10px;
`;

export const Button = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
    cursor: pointer;
    position: relative;
    transition: color .3s ease 0s, background-color .3s ease 0s;
    
    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &:before {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 20px;
        content: '${props => props.icon ?? ''}'
    }
`;

export const NoItems = styled.div`
    color: #ccc;
    text-align: center;
    font-size: 14px;
    flex: 1;
    margin: 20px 0;
`;

export const Message = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    padding: 5px;
    position: relative;
    cursor: pointer;

    &:hover {
        background-color: #222;
    }
`;

export const MessageIcon = styled.div`
    width: 30px;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #fff;
    border: 1px solid #0c0;
`;

export const UserName = styled.div`
    font-size: 14px;
    color: #fff;
    margin-left: 10px;
`;

export const NumOf = styled.span`
    color: #999;
    font-size: 12px;
`;